<template>
    <Transition name="slide-up">
        <div
            v-if="showPrompt"
            class="fixed bottom-4 left-4 right-4 z-[9999]"
        >
            <div
                class="flex items-center gap-3 rounded-2xl bg-white p-4 shadow-2xl ring-1 ring-black/10"
            >
                <!-- Logo -->
                <img
                    src="/favicon.png"
                    alt="Trekko"
                    class="h-12 w-12 rounded-xl"
                />

                <!-- Text -->
                <div class="min-w-0 flex-1">
                    <p class="font-semibold text-gray-900">
                        Install Trekko
                    </p>

                    <p class="text-sm text-gray-500">
                        Get faster access to events and tickets.
                    </p>
                </div>

                <!-- Install -->
                <button
                    @click="install"
                    class="rounded-xl bg-black px-4 py-2 text-sm font-semibold text-white"
                >
                    Install
                </button>

                <!-- Close -->
                <button
                    @click="dismiss"
                    class="text-gray-400"
                    aria-label="Close"
                >
                    ✕
                </button>
            </div>
        </div>
    </Transition>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import {
    installPWA,
    isPWAInstalled,
} from "../services/pwa";

const showPrompt = ref(false);

const handleInstallAvailable = () => {
    if (!isPWAInstalled()) {
        showPrompt.value = true;
    }
};

const handleInstalled = () => {
    showPrompt.value = false;
};

const install = async () => {
    const installed = await installPWA();

    if (installed) {
        showPrompt.value = false;
    }
};

const dismiss = () => {
    showPrompt.value = false;

    // Don't show again during this browser session
    sessionStorage.setItem(
        "trekko_install_dismissed",
        "true"
    );
};

onMounted(() => {
    if (isPWAInstalled()) {
        return;
    }

    if (
        sessionStorage.getItem(
            "trekko_install_dismissed"
        )
    ) {
        return;
    }

    window.addEventListener(
        "pwa-install-available",
        handleInstallAvailable
    );

    window.addEventListener(
        "pwa-installed",
        handleInstalled
    );
});

onUnmounted(() => {
    window.removeEventListener(
        "pwa-install-available",
        handleInstallAvailable
    );

    window.removeEventListener(
        "pwa-installed",
        handleInstalled
    );
});
</script>

<style scoped>
.slide-up-enter-active,
.slide-up-leave-active {
    transition: all 0.3s ease;
}

.slide-up-enter-from,
.slide-up-leave-to {
    opacity: 0;
    transform: translateY(30px);
}
</style>